import { render, staticRenderFns } from "./_reportsSection.vue?vue&type=template&id=0bcaf24c&scoped=true&"
import script from "./_reportsSection.vue?vue&type=script&lang=js&"
export * from "./_reportsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcaf24c",
  null
  
)

export default component.exports